export const STATE_NAME = 'sweepstakes';

export const initialState = {};

initialState[STATE_NAME] = {
	prizeId: null,
	lastSubmission: null,
	submissionResult: {},
	submissionStatus: 0
};

function updateStateObj(state, key, val) {
	const nextState = {...state};
	nextState.sweepstakes = {...state.sweepstakes};
	nextState.sweepstakes[key] = val || nextState[STATE_NAME][key];
	
	return nextState;
}

export function setPrizeId(state, action) {
	const key = 'prizeId';
	return updateStateObj(state, key, (action && action.data));
}

export function setSubmissionResult(state, action) {
	const key = 'submissionResult';
	return updateStateObj(state, key, (action && action.data));
}

export function resetSubmissionStatus(state, action) {
	const key = 'submissionStatus';
	return updateStateObj(state, key, initialState[STATE_NAME][key]);
}

export function setSubmissionStatus(state, action) {
	const key = 'submissionStatus';
	return updateStateObj(state, key, (action && action.data));
}

export function resetSubmissionResult(state, action) {
	const key = 'submissionResult';
	return updateStateObj(state, key, initialState[STATE_NAME][key]);
}

export function setLastSubmission(state, action) {
	const key = 'lastSubmission';
	return updateStateObj(state, key, (action && action.data));
}


// WEBPACK FOOTER //
// ./src/js/instantwinform/reducers/sweepstakes.js